import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getWarrantyTimeExceptions = createAsyncThunk('/GetWarrantyTimeExceptions', async () => {
    const response = await axios.get(`/GetWarrantyTimeExceptions`);
    return response.data;
});



export const setWarrantyTimeExceptions = createAsyncThunk('/SetWarrantyTimeExceptions', async (push) => {
    const response = await axios.post(`/SetWarrantyTimeExceptions`,push);
    return response.data;
});

export const getLanguagelist = createAsyncThunk(
    '/getLanguageList',
    async () => {
        const response = await axios.get('/GetLanguageList');
        return response.data;
    }
);

const warrantyTimeExceptionSlice = createSlice({
    name: 'warrantyTimeException',
    initialState: {
        loading: false,
        error: '',
        ProductWarrantyTimeExceptions: [],
        //WarrantyException:[],
        SelectedAppTranslationId: 0,
        response: '',
    },
    reducers: {
        changeSelectedAppTranslationId(state, action) {
            state.SelectedAppTranslationId = action.payload;
        },
    },

    extraReducers: {

        [getWarrantyTimeExceptions.pending]: (state) => {
            state.loading = true;
        },
        [getWarrantyTimeExceptions.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        [getWarrantyTimeExceptions.fulfilled]: (state, action) => {
            state.ProductWarrantyTimeExceptions = action.payload;
            state.loading = false;
        },
        [setWarrantyTimeExceptions.pending]: (state) => {
            state.loading = true;
        },
        [setWarrantyTimeExceptions.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        [setWarrantyTimeExceptions.fulfilled]: (state, action) => {
            state.ProductWarrantyTimeExceptions = action.payload;
            state.loading = false;
        },

    }
});

export const warrantyTimeExceptionActions = warrantyTimeExceptionSlice.actions

export default warrantyTimeExceptionSlice;
